import type App from "../index";
import { ScrollDirection, ScrollHandler } from "../classes/scroll-manager";
import { getEl, getEls } from '../helpers';
import anime from 'animejs';
import Analytics from "../classes/analytics";
import Globals from "../classes/globals";


export default class Modals
{

	public modals:{[p: string]:{
			name: string,
			el: Element,
			open: boolean,
		}} = {};

	constructor(app: App) {
		const els = getEls("#slb-report .modal[data-name]");

		this.modals = {};
		els.forEach((element) => {
			//@ts-ignore
			const name = element.dataset.name;

			this.modals[name] = {
				el: element,
				name: name,
				open: false,
			};

			element.addEventListener('open', () => {
				
				if (!this.modals[name].open) {
					Analytics.trackSpotlight(name.substring(0, 1).toUpperCase() + name.substring(1) + ' Spotlight');
				
					this.modals[name].open = true;
					document.body.style.overflow = 'hidden';
					//@ts-ignore
					this.modals[name].el.style.display = 'block';
					//@ts-ignore
					this.modals[name].el.style.visibility = 'visible';
	
					anime({
						targets: this.modals[name].el.querySelector('.modal-container'),
						clipPath: ['inset(0% 0% 0% 100%)', 'inset(0% 0% 0% 0%)'],
						easing: "easeInOutQuint",
						duration: 850,
					});
				}

			});
			element.addEventListener('close', () => {
				this.modals[name].open = false;
				document.body.style.removeProperty('overflow');

				anime({
					targets: this.modals[name].el.querySelector('.modal-container'),
					clipPath: ['inset(0% 0% 0% 0%)', 'inset(0% 0% 0% 100%)'],
					easing: "easeInOutQuint",
					duration: 850,
					complete: () => {
						//@ts-ignore
						this.modals[name].el.style.display = 'none';
						//@ts-ignore
						this.modals[name].el.style.visibility = 'hidden';
					}
				});
			});

			element.querySelector('.modal-close-button').addEventListener('click', (e) =>{
				e.preventDefault();
				this.closeModal(name);
			})

		});

	}


	public openModal(name:string) {
		if (this.modals.hasOwnProperty(name)){
			this.modals[name].el.dispatchEvent(new CustomEvent("open"));
		} else {
			console.error("No modal with the name ", name);
		}
	}
	public closeModal(name:string) {
		if (this.modals.hasOwnProperty(name)){
			this.modals[name].el.dispatchEvent(new CustomEvent("close"));
		} else {
			console.error("No modal with the name ", name);
		}
	}



}
